import { defineStore } from 'pinia';
import { ref } from 'vue';

export type NotificationType = 'info' | 'success' | 'warning' | 'error';

export interface Notification {
  id: string;
  type: NotificationType;
  title?: string;
  message: string;
  // 毫秒；0 表示不自动关闭。
  duration?: number;
  timestamp: number;
}

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref<Notification[]>([]);

  const add = (message: string, type: NotificationType = 'info', title?: string, duration: number = 5000) => {
    const id = Date.now().toString(36) + Math.random().toString(36).substr(2);
    const notification: Notification = {
      id,
      type,
      title,
      message,
      duration,
      timestamp: Date.now(),
    };
    notifications.value.push(notification);

    if (duration > 0) {
      setTimeout(() => {
        remove(id);
      }, duration);
    }

    return id;
  };

  const remove = (id: string) => {
    const index = notifications.value.findIndex(n => n.id === id);
    if (index !== -1) {
      notifications.value.splice(index, 1);
    }
  };

  const clear = () => {
    notifications.value = [];
  };

  // 便捷方法
  const info = (message: string, title?: string, duration?: number) => add(message, 'info', title, duration);
  const success = (message: string, title?: string, duration?: number) => add(message, 'success', title, duration);
  const warning = (message: string, title?: string, duration?: number) => add(message, 'warning', title, duration);
  const error = (message: string, title?: string, duration?: number) => add(message, 'error', title, duration);

  return {
    notifications,
    add,
    remove,
    clear,
    info,
    success,
    warning,
    error,
  };
});
